import { render } from "./Lastorder.vue?vue&type=template&id=69979d2e"
import script from "./Lastorder.vue?vue&type=script&lang=js"
export * from "./Lastorder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__